(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSAnioDetailController', SSAnioDetailController);

    SSAnioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSAnio', 'SSPeriodo'];

    function SSAnioDetailController($scope, $rootScope, $stateParams, previousState, entity, SSAnio, SSPeriodo) {
        var vm = this;

        vm.sSAnio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSAnioUpdate', function(event, result) {
            vm.sSAnio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
